import React, {Component} from 'react';
import './CustomerGroupsAdd.css';
import Inputs from '../../../../shared/FormComponents/Inputs';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import uuidv1 from 'uuid/v1';


class CustomerGroupsAdd extends Component {
    constructor(props) {
      super(props);
      this.defaultParams = {};
      this.state = {
          group: '',
          formValid: false,
        data: {
            group: '',
        },
        inputStates: {
            group: false,
        }
      };
    }

    componentWillMount(){
        
    }

    onDataChange = (key, value, valid) => {
        const state = _.extend({}, this.state);
        state.inputStates[key] = valid;
        state.data[key] = value;
        this.setState(state, () => this.validateForm());
    };

    onChangeValue = (value) => {
        this.setState({
            group: value,
        })
        if(value.length > 3){
            this.setState({
                formValid: true,
            })
        }
        
    }
    
    validateForm = () => {
        let validationStates = _.extend({}, this.state.inputStates);
        let key = Object.values(validationStates).indexOf(false) !== -1;
        let state = !key;
        this.setState({ formValid: state });
    }

    addCustomerGroup = () => {
        if(this.state.group){
            let data = {
                groupId: uuidv1(),
                groupName: this.state.group,
            }
            this.props.addCustomerGroups(data);
        }
    }

    render() {
        return(
            <div className='row'>
                <div className='col-sm-12'>
                    <div className='customer-groups-add-content'>
                        <form>
                            <div className="form-group">
                                    <input type="text" className='form-control'
                                    onChange={(e) => this.onChangeValue(e.target.value)} onKeyPress={(e)=>{ e.key == 'Enter' && this.addCustomerGroup()}
                                    }/>
                            </div> 
                            <div className={ this.state.formValid ? 'btn btn-success' : 'btn btn-success disabled' } onClick={this.addCustomerGroup} >Add</div>
                        </form> 
                    </div>
                </div>
            </div>
        ) 
    }
}

export default (CustomerGroupsAdd);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerGroups/CustomerGroupsAdd/CustomerGroupsAdd.jsx